import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { Box } from '@mui/material';

const opcoes = [
  { key: 'A', label: 'Comprimidos/cápsulas orais' },
  { key: 'B', label: 'Suspensão, xaropes' },
  { key: 'C', label: 'Injecção' },
  { key: 'D', label: 'Diluente' },
  { key: 'E', label: 'Pó para reconstituição da suspensão' },
  { key: 'F', label: 'Pó para reconstituição de injectáveis' },
  { key: 'G', label: 'Gotas oftálmicas' },
  { key: 'H', label: 'Gotas nasais' },
  { key: 'I', label: 'Gotas auriculares' },
  { key: 'J', label: 'Nebulizadores' },
  { key: 'K', label: 'Cremes, pomadas, pastas, linimentos' },
  { key: 'OUTROS', label: 'Outros' },
];

interface ModalApresentacaoProdutoProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (result: any) => void;
  initialValue?: {
    [key: string]: boolean | string;
  };
}

const ModalApresentacaoProduto: React.FC<ModalApresentacaoProdutoProps> = ({ open, onClose, onConfirm, initialValue }) => {
  const [checks, setChecks] = useState<{ [key: string]: boolean }>(() => {
    const obj: { [key: string]: boolean } = {};
    opcoes.forEach(opt => {
      obj[opt.key] = Boolean(
        initialValue?.[opt.key] ??
        initialValue?.[`identificacaoProductoApresentacaoProducto${opt.key}`]
      );
    });
    return obj;
  });
  const [outros, setOutros] = useState<string>(
    typeof initialValue?.identificacaoProductoApresentacaoProductoOutros === 'string'
      ? (initialValue?.identificacaoProductoApresentacaoProductoOutros as string)
      : ''
  );

  const handleCheck = (key: string) => {
    setChecks(prev => {
      const updated = { ...prev, [key]: !prev[key] };
      if (key !== 'OUTROS') return updated;
      if (!updated['OUTROS']) setOutros('');
      return updated;
    });
  };

  const handleConfirm = () => {
    const result: any = {};
    opcoes.forEach(opt => {
      if (opt.key === 'OUTROS') {
        result[`identificacaoProductoApresentacaoProductoOutros`] = checks[opt.key] ? outros : '';
      } else {
        result[`identificacaoProductoApresentacaoProducto${opt.key}`] = checks[opt.key] === true;
      }
    });
    result.checks = checks;
    result.outros = outros;
    onConfirm(result);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Selecionar apresentação do produto</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {opcoes.filter(opt => opt.key !== 'OUTROS').map(opt => (
            <Grid item xs={12} sm={6} md={4} key={opt.key}>
              <div
                style={{
                  background: checks[opt.key] ? '#85287E' : '#f6f2fc',
                  borderRadius: 8,
                  padding: 12,
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'background 0.2s',
                  color: checks[opt.key] ? '#fff' : '#85287E',
                }}
              >
                <FormControlLabel
                  control={<Checkbox checked={checks[opt.key]} onChange={() => handleCheck(opt.key)} style={{ color: checks[opt.key] ? '#fff' : '#85287E' }} />}
                  label={<span style={{ fontWeight: 500, color: checks[opt.key] ? '#fff' : '#85287E' }}>{opt.label}</span>}
                />
              </div>
            </Grid>
          ))}
        </Grid>
        <Box mt={4}>
          <div
            style={{
              background: '#f6f2fc',
              borderRadius: 8,
              padding: 16,
              color: checks['OUTROS'] ? '#85287E' : '#85287E',
              transition: 'background 0.2s',
            }}
          >
            <FormControlLabel
              control={<Checkbox checked={checks['OUTROS']} onChange={() => handleCheck('OUTROS')} style={{ color: checks['OUTROS'] ? '#85287E' : '#85287E' }} />}
              label={<span style={{ fontWeight: 500, color: '#85287E' }}>Outros</span>}
            />
            {checks['OUTROS'] && (
              <TextField
                label="Descreva outros"
                fullWidth
                value={outros}
                onChange={e => setOutros(e.target.value)}
                style={{ marginTop: 12 }}
                InputLabelProps={{ style: { color: '#85287E' } }}
              />
            )}
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          style={{ background: '#85287E', color: '#fff', fontWeight: 600 }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalApresentacaoProduto;
